import { render, staticRenderFns } from "./ReadonlyCheckbox.vue?vue&type=template&id=55d3d4cd&scoped=true&lang=pug&"
import script from "./ReadonlyCheckbox.vue?vue&type=script&lang=js&"
export * from "./ReadonlyCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d3d4cd",
  null
  
)

export default component.exports